import useWalletFundedTracker from '@plug-core/hooks/useWalletFundedTracker'

export const WalletFundedTracker = () => {
  useWalletFundedTracker()
  return null
}
